module.exports = __webpack_public_path__ + "static/media/How_your_diet_can_treat_diseases.260d198f.jpg";